import { CenteredSpinner } from '~/commonComponents';
import '../../../../themes/global.scss';

import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import browserHistory from '~/browserHistory';
import { useCanPostShifts } from '~/hooks';
import { FilterStatusEnum } from '~/utils/Enum';
import { ReportIncidentPopup } from '~/components/JobList/TodayJobs/ReportIncidentPopup/ReportIncidentPopup';
import { EmptyScreen } from '../../../../commonComponents/EmptyScreen/EmptyScreen';
import { getEmptyFilteredScreen, onCardClick } from '../../utils';
import { JobCard } from '../JobCard/JobCard';
import { useJobList } from './useJobList';

export const JobList = ({ status }) => {
  const { jobList, isLoadingList, sentinelRef } = useJobList({ status });
  const { actionRequired } = useSelector((state) => state.job.dashboardInfo) || {};
  const canPostShifts = useCanPostShifts();

  if (jobList?.length === 0 && !isLoadingList) {
    const { Icon, title, description, buttonText, buttonLink } = getEmptyFilteredScreen(status);

    const emptyScreenProps = {
      Icon,
      title,
      description,
      buttonText,
      ...(canPostShifts && (status !== FilterStatusEnum.SCHEDULED || actionRequired)
        ? { onButtonClick: () => browserHistory.push(buttonLink) }
        : {}),
    };

    return (
      <motion.div
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          height: 750,
        }}
      >
        <EmptyScreen {...emptyScreenProps} />
      </motion.div>
    );
  }

  return (
    <div className="w-full">
      {/* No fixed-height inner scroll — the shifts flow on the page and the page
          scroll drives pagination (via the sentinel below). */}
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-3 py-5">
        {jobList?.map((job) => (
          <JobCard key={job.id} onCardClick={onCardClick} job={job} />
        ))}
        {isLoadingList && (
          <div className="my-10">
            <CenteredSpinner />
          </div>
        )}
        <div ref={sentinelRef} />
      </div>
      {/* Single redux-driven popup shared by the current-shift cards' report flow. */}
      <ReportIncidentPopup />
    </div>
  );
};
